import { NgModule } from '@angular/core';

import * as ApiServiceProxies from './service-proxies';

@NgModule({
    providers: [
        ApiServiceProxies.AccountServiceProxy,
        ApiServiceProxies.AuditLogServiceProxy,
        ApiServiceProxies.CachingServiceProxy,
        ApiServiceProxies.ChatServiceProxy,
        ApiServiceProxies.CommonLookupServiceProxy,
        ApiServiceProxies.EditionServiceProxy,
        ApiServiceProxies.FeatureManagementServiceProxy,
        ApiServiceProxies.FriendshipServiceProxy,
        ApiServiceProxies.HostDashboardServiceProxy,
        ApiServiceProxies.HostSettingsServiceProxy,
        ApiServiceProxies.LanguageServiceProxy,
        ApiServiceProxies.MetadataServiceProxy,
        ApiServiceProxies.NotificationServiceProxy,
        ApiServiceProxies.OrganizationUnitServiceProxy,
        ApiServiceProxies.PaymentServiceProxy,
        ApiServiceProxies.PermissionServiceProxy,
        ApiServiceProxies.ProfileServiceProxy,
        ApiServiceProxies.ResetPasswordServiceProxy,
        ApiServiceProxies.RoleServiceProxy,
        ApiServiceProxies.RulesServiceProxy,
        ApiServiceProxies.SessionServiceProxy,
        ApiServiceProxies.SubmittersServiceProxy,
        ApiServiceProxies.TenantDashboardServiceProxy,
        ApiServiceProxies.TenantRegistrationServiceProxy,
        ApiServiceProxies.TenantServiceProxy,
        ApiServiceProxies.TenantSettingsServiceProxy,
        ApiServiceProxies.TimingServiceProxy,
        ApiServiceProxies.TokenAuthServiceProxy,
        ApiServiceProxies.TransformsServiceProxy,
        ApiServiceProxies.UserLinkServiceProxy,
        ApiServiceProxies.UserLoginServiceProxy,
        ApiServiceProxies.UserServiceProxy,
        ApiServiceProxies.WebLogServiceProxy,
        ApiServiceProxies.WorkflowServiceProxy,
        ApiServiceProxies.FileSubmissionServiceProxy,
        ApiServiceProxies.SubmittersSubmissionHistoryServiceProxy,
        ApiServiceProxies.IssueCorrectionServiceProxy,
        ApiServiceProxies.ProductServiceProxy,
        ApiServiceProxies.PartyServiceProxy,
        ApiServiceProxies.TrashProductsServiceProxy,
        ApiServiceProxies.ReferenceDataServiceProxy
    ]
})
export class ServiceProxyModule { }
